<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { renderSiteFooter } from '../site/chrome'

const { t, locale } = useI18n()

const year = new Date().getFullYear()

// Shared with the static pages, so both surfaces emit identical markup.
const html = computed(() =>
  renderSiteFooter((key, params) => t(key, params ?? {}), locale.value, year),
)
</script>

<template>
  <!-- Built from catalog strings, escaped by the renderer; never user input. -->
  <div class="site-footer-host" v-html="html" />
</template>
